import { render } from "./ProofOfIdentity.vue?vue&type=template&id=08853432&scoped=true"
import script from "./ProofOfIdentity.vue?vue&type=script&lang=js"
export * from "./ProofOfIdentity.vue?vue&type=script&lang=js"

import "./ProofOfIdentity.vue?vue&type=style&index=0&id=08853432&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08853432"]])

export default __exports__